export const headerCode = `headers: {
  "party-id": "GBXRIBT001",
  "client-id": "6789aa",
  "x-api-key": "EdX2C9Yeku3dVLSaYe2RI2iBnFXoSEgB11gsOwSX",
  "authorization": \`Bearer \${accessToken}\`,
  "Content-Type": "application/json"
}`

export const bodyCode = `//This is an example DROP IN shipment and will need the quoteId
//of a quote that has "serviceType": "DROP_IN".
{
  "quoteId": "fedex-62a59ee3-ce79-4663-a78c-54c76yughj1a64",
  "bookingConfirmationEmail": "confirmation_receiver@airmenzies.com",
  "customerCloseTime": "17:00",
  "shipmentDateTime": "2025-09-26T00:00:01Z",
  "unitOfMeasurement": "METRIC",
  "unitOfCurrency": "GBP",
  "senderDetails": {
    "address": {
      "organisation": "AMI Edinburgh",
      "streetLines": [
        "2 Lochside Avenue"
      ],
      "countryCode": "GB",
      "postalCode": "EH12 9DJ",
      "city": "Edinburgh",
      "residential": false
    },
    "contactDetails": {
      "name": "Richard",
      "telephone": "0123654789"
    },
    "notificationDetails": {
      "email": "richard@senderparty0.com",
      "mobile": "9876543210"
    }
  },
  "deliveryDetails": {
    "address": {
      "organisation": "AMI Melbourne",
      "streetLines": [
        "Melbourne Airport"
      ],
      "stateOrCounty": "VIC",
      "countryCode": "AU",
      "postalCode": "3045",
      "city": "Melbourne",
      "residential": false
    },
    "contactDetails": {
      "name": "Petra",
      "telephone": "9874563210"
    },
    "notificationDetails": {
      "email": "petra@deliverycustomer0.com",
      "mobile": "0123654789"
    }
  },
  "customsDetails": {
    "declaredValue": 500,
    "invoiceDetails": {
      "termsOfSale": "DAP",
      "taxDetails": [
        {
          "type": "VAT",
          "party": "SENDER",
          "value": "GBVAT123456"
        }
      ],
      "exportReason": "SOLD"
    },
    "commodities": [
      {
        "commodityCode": "123456789",
        "description": "Plastic items for decoration",
        "countryOfOrigin": "GB",
        "quantity": {
          "value": 1,
          "unit": "PCS"
        },
        "unitPrice": {
          "value": 500
        },
        "weight": {
          "value": "10.0",
          "unit": "KG"
        }
      }
    ]
  },
  "parcels": [
    {
      "dimensions": {
        "length": "10.0",
        "width": "10.0",
        "height": "10.0",
        "unit": "CM"
      },
      "weight": {
        "value": "10.0",
        "unit": "KG"
      }
    }
  ],
  "customerShippingReference": "SHIP - 13579",
  "contentDescription": "Plastic decorations",
  "specialInstructions": "Leave at reception",
  "shipmentType": "NON_DOCS",
  "label": {
    "type": "PDF",
    "size": "A4"
  }
}`

export const exampleSuccessResponse = `[
  {
    "amiReference": "AMIGB1234567890",
    "shipmentId": "123456789",
    "alerts": [],
    "consignmentDetailsList": [
      {
        "consignmentNumber": null,
        "parcelNumbers": [
          "JD014600004922589631"
        ]
      }
    ],
    "consolidated": null,
    "pickupConfirmationCode": {if collected shipment},
    "pickupMessage": {if collected shipment},
    "regionId": "GBX"
  }
]`

export const exampleErrorResponses = {
  1000: `{
    "message": "Bad Request",
    "errors": [
      {
        "code": "1000",
        "message": "must not be null",
        "fieldName": "quoteId",
        "value": null
      }
    ]
  }`,
  1010: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must not be null for country code US",
        "code": "1010",
        "fieldName": "deliveryDetails.address.stateOrCounty",
        "value": null
      }
    ]
  }`,
  1100: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be 'true' or 'false'",
        "code": "1100",
        "fieldName": "deliveryDetails.address.residential",
        "value": ""
      }
    ]
  }`,
  1200: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be a number",
        "code": "1200",
        "fieldName": "parcels[0].dimensions.height",
        "value": "one"
      }
    ]
  }`,
  1210: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be up to 2 decimal places only",
        "code": "1210",
        "fieldName": "parcels[0].dimensions.height",
        "value": "10.123"
      }
    ]
  }`,
  1220: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be between 1 and 3",
        "code": "1220",
        "fieldName": "parcels[0].dimensions.height",
        "value": "5"
      }
    ]
  }`,
  1230: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be equal to or greater than 1",
        "code": "1230",
        "fieldName": "parcels[0].dimensions.height",
        "value": "0"
      }
    ]
  }`,
  1240: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be equal to or less than 4",
        "code": "1240",
        "fieldName": "parcels[0].dimensions.height",
        "value": "10"
      }
    ]
  }`,
  1300: `{
    "message": "Bad Request",
    "errors": [
      {
        "code": "1300",
        "message": "must be one of",
        "values": ["NON_DOCS", "DOCS"]
        "fieldName": "shipmentType",
        "value": "<invalid value>"
      }
    ]
  }`,
  1310: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be one of for country code MX",
        "code": "1310",
        "fieldName": "deliveryDetails.address.stateOrCounty",
        "value": "L",
        "values": [
            "AG",
            "BC",
            "BS",
            "CM",
            "CS",
            "CH",
            "DF",
            "CO",
            "CL",
            "DG",
            "EM",
            "GT",
            "GR",
            "HG",
            "JA",
            "MI",
            "MO",
            "NA",
            "NL",
            "OA",
            "PU",
            "QE",
            "QR",
            "SL",
            "SI",
            "SO",
            "TB",
            "TM",
            "TL",
            "VE",
            "YU",
            "ZA"
        ]
      }
    ]
  }`,
  1320: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be one of when label.type is PDF",
        "code": "1320",
        "fieldName": "label.size",
        "value": "STOCK_4X6",
        "values": [
            "A4",
            "US_LETTER"
        ]
      }
    ]
  }`,
  1400: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "length must be between 3 and 35",
        "code": "1400",
        "fieldName": "deliveryDetails.address.organisation",
        "value": "",
        "min": 3,
        "max": 35
      }
    ]
  }`,
  1500: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be in the format",
        "code": "1500",
        "fieldName": "deliveryDetails.notificationDetails.email",
        "value": "m@c+.com",
        "format": "^[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
      }
    ]
  }`,
  1510: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must be in the format for country code US",
        "code": "1510",
        "fieldName": "deliveryDetails.address.postalCode",
        "value": "INVALID",
        "format": "^\\d{5}([ \\-]\\d{4})?$"
      }
    ]
  }`,
  1600: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "must not be empty",
        "code": "1600",
        "fieldName": "deliveryDetails.address.streetLines",
        "value": []
      }
    ]
  }`,
  1610: `{
    "message": "Bad Request",
    "errors": [
      {
        "message": "size must be between 1 and 3",
        "code": "1610",
        "fieldName": "deliveryDetails.address.streetLines",
        "value": [
          "Delivery Street Line 1",
          "Delivery Street Line 2",
          "Delivery Street Line 3",
          "Delivery Street Line 4"
        ],
        "min": 1,
        "max": 3
      }
    ]
  }`
}